import { Box, useTranslation } from '@common';
import { DragItem, Highlighter } from '../../component';
import styles from '../style.module.less';
import { usePrimaryColor } from '../../hooks';
import { service } from '../service';
import { RichTextComponent } from './richText';
import type { ReactElement } from 'react';
import type { RichTextProps } from './types';

export function RichTextDesignMode(props: RichTextProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();

  if (props.name == null) {
    return (
      <DragItem title={t('RichText')} />
    );
  }

  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <RichTextComponent {...props} />
      </Box>
    </Box>
  );
}
